import { cn } from 'common/utils';

interface CloseButtonPropsType {
  onClick: () => void;
  className?: string;
}

export default function CloseButton({
  onClick,
  className = '',
}: CloseButtonPropsType) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'absolute right-4 top-4 z-10 flex size-8 items-center justify-center rounded-full text-2xl text-pp-text-primary transition-all hover:text-pp-text-secondary',
        className ?? '',
      )}
    >
      ×
    </button>
  );
}
